import React from 'react';
import PropTypes from 'prop-types';

import { Route } from 'react-router-dom';
import Loading from '../loading';

const WeezBoRoute = ({ path, weezRoute }) => {
    return (
        <Route
            exact
            path={path}
            render={() => {
                window.location = weezRoute;
                return <Loading />;
            }}
        />
    );
};

WeezBoRoute.propTypes = {
    path: PropTypes.string.isRequired,
    weezRoute: PropTypes.string.isRequired
};

export default WeezBoRoute;
